import { render, staticRenderFns } from "./templateLazada.vue?vue&type=template&id=cb221f0c&scoped=true"
import script from "./templateLazada.vue?vue&type=script&lang=js"
export * from "./templateLazada.vue?vue&type=script&lang=js"
import style0 from "./templateLazada.vue?vue&type=style&index=0&id=cb221f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb221f0c",
  null
  
)

export default component.exports